export default "/images/contest2.jpg?a906647aa06593929497808a3cec0604";